module.exports = __webpack_public_path__ + "img/noOpen.3cc51aaf.png";